import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Claim,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}`;

export interface GetClaimByClaimIdArgs {
  claimId: string;
}

export const getClaimByClaimIdRequest = (
  payload: GetClaimByClaimIdArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, payload.claimId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getClaimByClaimId = async (
  payload: GetClaimByClaimIdArgs,
): Promise<BackResponse<Claim> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Claim>>(
      getClaimByClaimIdRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getClaimByClaimId;
